import { render, staticRenderFns } from "./wuziChukuForm.vue?vue&type=template&id=7ed4167d&scoped=true&"
import script from "./wuziChukuForm.vue?vue&type=script&lang=js&"
export * from "./wuziChukuForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed4167d",
  null
  
)

export default component.exports